var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRembardeCassee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fond",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 592.58 607.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rembarde cass\xE9e") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "abim\\xE9e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1854,1735l9-44-12-28,3.24-15.9,67.34-112.89v-14.1L1851,1640l-75,58-225,143-137,103-69,15-16,8,2,4,4.47-4v161l584-440.42v-2.7Zm-513,381.15V1964.59l74.34-15.89L1423,2004l-15,61Zm73.12-54.3L1426,2004l-4.93-59.71,67.74-50.07L1481,1919l1,91Zm73.5-54.51L1486,1919l8.57-29.22,66.83-49.49,2.6,7.71-16,66,7,42Zm72.61-53.91L1553,1913l16-66-1.82-11.13L1628,1800l9,36-9,66Zm73.5-54.5L1643,1833l-9-36,67-46.52,9,45.52-8,51Zm73.12-54.31L1714,1795l-7.2-48.94,68.16-40-8,54,9,33Zm73.92-54.47L1773,1760l7.72-58.41,67.74-50.08L1847,1663l13,29-11,46Z",
    transform: "translate(-1329 -1520.11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRembardeCassee);
export default __webpack_public_path__ + "static/media/rembarde_cassee.cb205f51830d3261579c71e3910caa33.svg";
export { ForwardRef as ReactComponent };